module.exports = __webpack_public_path__ + "img/folder-plus.d85f4863.svg";